import { graphql } from "@/graphql/generated/gql";

export const getAssigneeQueryDocument = graphql(/* GraphQL */ `
  query Assignee($input: GetAssigneeInput!) {
    assignee(getAssigneeInput: $input) {
      ...AssigneeFields
    }
  }
`);

export const getAssigneeByOwnerQueryDocument = graphql(/* GraphQL */ `
  query AssigneeByOwner($input: GetAssigneeListByOwnerInput!) {
    assigneeByOwner(getAssigneeListByOwnerInput: $input) {
      ...AssigneeFields
    }
  }
`);

export const createAssigneeMutationDocument = graphql(/* GraphQL */ `
  mutation createAssignee($input: CreateAssigneeInput!) {
    createAssignee(createAssigneeInput: $input) {
      ...AssigneeFields
    }
  }
`);

export const updateAssigneeMutationDocument = graphql(/* GraphQL */ `
  mutation updateAssignee($input: UpdateAssigneeInput!) {
    updateAssignee(updateAssigneeInput: $input) {
      ...AssigneeFields
    }
  }
`);

export const deleteAssigneeMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteAssignee($input: DeleteAssigneeInput!) {
    deleteAssignee(deleteAssigneeInput: $input) {
      ...AssigneeFields
    }
  }
`);

export const bulkCreateAssigneeMutationDocument = graphql(/* GraphQL */ `
  mutation BulkCreateAssignee($input: BulkCreateAssigneeInput!) {
    bulkCreateAssignee(bulkCreateAssigneeInput: $input) {
      successCount
      errorCount
    }
  }
`);

export const bulkDeleteAssigneeByOwnerMutationDocument = graphql(/* GraphQL */ `
  mutation BulkDeleteAssigneeByOwner($input: BulkDeleteAssigneeByOwnerInput!) {
    bulkDeleteAssigneeByOwner(bulkDeleteAssigneeByOwnerInput: $input) {
      successCount
      errorCount
    }
  }
`);
